// TODO:    maybe these type of controllers should have their own place.
//          maybe such things like a modal controller would come in handy these days. => this would lead to actions stored within the client which do not have to be prepared by the server. therefor no shadowComponents and server requests would be necessary.
//          the same thing could be applied to error displays, deciders, ...

// @see MARK: GLOBAL_ACTIONS_VIA_CONTROLLERS within frontend-controller/server/globalActions.js for further details.

const utils     = require('../../utils')
const CONSTANTS = require('../../constants')

module.exports = {

    actions: {
        openModal: {
            type: CONSTANTS.COMPONENT.ACTION.TYPE.LOAD,
            source: {
                load: {
                    componentData: {
                        // component will be set at runtime @see getAction()
                        // component: [
                        //     '/',
                        //     'base',
                        //     'form',
                        //     'media',
                        //     'upload',
                        //     'plupload',
                        // ]
                        model: {
                            titleKey: 'modal.instantImageUploader.title',
                            // subTitle: ''
                            buttons: [
                                {
                                    buttonType: 'cancel',
                                    mode: 'close'
                                }
                            ],
                        },
                        actions: {
                            loadContent: {
                                source: {
                                    load: {
                                        componentData: {
                                            config: {
                                                autoOpenUploadDialog: true,
                                                isInstantUploader: true,
                                            }
                                            // component will be set at runtime @see getAction()
                                            // component: [
                                            //     '/',
                                            //     'base',
                                            //     'form',
                                            //     'media',
                                            //     'upload',
                                            //     'plupload',
                                            // ]
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            },
            target: {
                position: CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.MODAL,
            }
        }
    },

    /**
     * returns an action definition replacing the given $trigger with a popover surrounding this trigger.
     * action.source.container refers to the popover itself.
     * action.source.content refers to the content of the popover which has to be extended by the callee.
     *
     * @returns action object
     */
    getAction(modalComponentDataExtension, uploaderComponentDataExtension){
        const action = utils.simpleCopy(this.actions.openModal)

        if(modalComponentDataExtension){
            utils.refMerge(action.source.load.componentData, modalComponentDataExtension)
        }
        action.source.load.componentData.component = action.source.load.componentData.component || [
            '/',
            'base',
            'modal',
            'modal',
        ]

        if(uploaderComponentDataExtension){
            utils.refMerge(action.source.load.componentData.actions.loadContent.source.load.componentData, uploaderComponentDataExtension)
        }
        action.source.load.componentData.actions.loadContent.source.load.componentData.component = action.source.load.componentData.actions.loadContent.source.load.componentData.component || [
            '/',
            'base',
            'form',
            'media',
            'upload',
            'plupload',
            'plupload',
        ]

        return action
    },
}